import React, { useState } from 'react';
import ApiDashboard from './ApiDashboard';

/**
 * API Dashboard Page - ApiDashboard 컴포넌트 래퍼
 * 필요한 props를 관리하고 전달
 */
const ApiDashboardPage = () => {
  const [apiFilter, setApiFilter] = useState('all');
  const [activeTooltip, setActiveTooltip] = useState(null);

  // API 엔드포인트 목록
  const apiList = [
    // 인증
    { id: 1, category: '인증', method: 'POST', endpoint: '/api/auth/login', description: '로그인', status: 'completed', priority: 'high' },
    { id: 2, category: '인증', method: 'POST', endpoint: '/api/auth/signup', description: '회원가입', status: 'completed', priority: 'high' },
    { id: 3, category: '인증', method: 'POST', endpoint: '/api/auth/social-login', description: '소셜 로그인', status: 'completed', priority: 'high' },
    { id: 4, category: '인증', method: 'GET', endpoint: '/api/auth/me', description: '현재 사용자 정보', status: 'completed', priority: 'high' },
    { id: 5, category: '인증', method: 'POST', endpoint: '/api/auth/logout', description: '로그아웃', status: 'completed', priority: 'medium' },

    // 사용자
    { id: 6, category: '사용자', method: 'GET', endpoint: '/api/users', description: '전체 회원 목록', status: 'completed', priority: 'high' },
    { id: 7, category: '사용자', method: 'GET', endpoint: '/api/users/pending', description: '승인 대기 회원', status: 'completed', priority: 'high' },
    { id: 8, category: '사용자', method: 'POST', endpoint: '/api/users/:id/approve', description: '회원 승인', status: 'completed', priority: 'high' },
    { id: 9, category: '사용자', method: 'PUT', endpoint: '/api/users/:id/tier', description: '등급 변경', status: 'completed', priority: 'medium' },

    // AI
    { id: 10, category: 'AI', method: 'POST', endpoint: '/api/ai/chat', description: 'AI 채팅', status: 'completed', priority: 'high' },
    { id: 11, category: 'AI', method: 'GET', endpoint: '/api/ai/usage', description: 'AI 사용량 조회', status: 'completed', priority: 'medium' },
    { id: 12, category: 'AI', method: 'GET', endpoint: '/api/api-keys', description: 'API 키 목록', status: 'completed', priority: 'high' },

    // 커뮤니티
    { id: 13, category: '커뮤니티', method: 'GET', endpoint: '/api/community/posts', description: '게시글 목록', status: 'completed', priority: 'high' },
    { id: 14, category: '커뮤니티', method: 'POST', endpoint: '/api/community/posts', description: '게시글 작성', status: 'completed', priority: 'high' },
    { id: 15, category: '커뮤니티', method: 'GET', endpoint: '/api/community/posts/:id', description: '게시글 상세', status: 'completed', priority: 'high' },

    // 파일
    { id: 16, category: '파일', method: 'POST', endpoint: '/api/files/upload', description: '파일 업로드', status: 'completed', priority: 'medium' },
    { id: 17, category: '파일', method: 'GET', endpoint: '/api/files/view/:filename', description: '파일 조회', status: 'completed', priority: 'medium' },

    // 알림
    { id: 18, category: '알림', method: 'GET', endpoint: '/api/notifications', description: '알림 목록', status: 'completed', priority: 'medium' },
    { id: 19, category: '알림', method: 'PUT', endpoint: '/api/notifications/:id/read', description: '알림 읽음 처리', status: 'completed', priority: 'low' },
  ];

  // API 키 상태 (실제로는 서버에서 로드)
  const apiKeyStatus = {
    openai: true,
    groq: true,
    gemini: true,
    anthropic: false,
  };

  // API ID와 키 매핑
  const apiKeyMapping = {
    10: 'groq',  // AI 채팅
    11: 'groq',  // AI 사용량
  };

  const handleStatusClick = (api) => {
    console.log('Status clicked:', api);
    // API 키 관리 페이지로 이동하거나 모달 표시
  };

  return (
    <ApiDashboard
      apiList={apiList}
      apiFilter={apiFilter}
      setApiFilter={setApiFilter}
      apiKeyStatus={apiKeyStatus}
      apiKeyMapping={apiKeyMapping}
      handleStatusClick={handleStatusClick}
      activeTooltip={activeTooltip}
      setActiveTooltip={setActiveTooltip}
    />
  );
};

export default ApiDashboardPage;
